import React, { useState } from 'react';
import './MaskedPhone.css';

/**
 * Telefon nömrəsi gizli göstərilir, üzərinə klikləyəndə açılır.
 *
 * Ölkə kodu və operator kodu görünür (kimin nömrəsi olduğu bilinsin),
 * ortadakı rəqəmlər gizlədilir, son iki rəqəm isə tanımaq üçün saxlanılır:
 *     +994 50 310 05 05  ->  +994 50 ••• •• 05
 *
 * Nömrə kifayət qədər uzun deyilsə maskalanmır — qısa dəyəri gizlətməyin
 * mənası yoxdur və səhv kəsilmə riski var.
 */
const VISIBLE_HEAD = 5;   // 99450
const VISIBLE_TAIL = 2;   // son iki rəqəm

export function maskPhone(raw) {
  const digits = String(raw || '').replace(/\D/g, '');
  if (digits.length < VISIBLE_HEAD + VISIBLE_TAIL + 2) return String(raw || '');
  const head = digits.slice(0, VISIBLE_HEAD);
  const tail = digits.slice(-VISIBLE_TAIL);
  const hidden = '•'.repeat(digits.length - VISIBLE_HEAD - VISIBLE_TAIL);
  return `+${head} ${hidden} ${tail}`;
}

export default function MaskedPhone({ value, className = '' }) {
  const [shown, setShown] = useState(false);
  if (!value) return <span className="mph-empty">—</span>;

  return (
    <button
      type="button"
      className={('mph ' + (shown ? 'open ' : '') + className).trim()}
      title={shown ? 'Gizlətmək üçün klikləyin' : 'Nömrəni görmək üçün klikləyin'}
      onClick={(e) => { e.stopPropagation(); setShown(s => !s); }}
    >
      {shown ? value : maskPhone(value)}
    </button>
  );
}
